//EXTERNAL
import { useEffect, useState } from "react";
//ASSETS
import placeholder from "../../../../assets/placeholder-background-story.jpg";

// Adds blur effect to preview image on load state
export function BlurryImage() {
  return ({ src }: { src: string }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
      if (!isLoaded) {
        const timeoutId = setTimeout(() => setIsLoaded(false), 3000);
        return () => clearTimeout(timeoutId);
      }
    }, [isLoaded]);

    return (
      <img
        src={src}
        onLoad={() => setIsLoaded(true)}
        alt="ad preview thumbnail"
        loading={"lazy"}
        style={{ borderRadius: "10px", maxWidth: "60px", maxHeight: "85px", filter: isLoaded ? "none" : "blur(5px)", transition: "filter .4s ease-in-out" }}
        onError={(e: any) => {
          e.target.src = placeholder;
        }}
      />
    );
  };
}
